import { render, staticRenderFns } from "./EventTicketManager.vue?vue&type=template&id=1944033b&"
import script from "./EventTicketManager.vue?vue&type=script&lang=js&"
export * from "./EventTicketManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports